export const FORNECEDORAPAGAR = 'FORNECEDORAPAGAR';
export const FORNECEDORAPAGAR_START = 'FORNECEDORAPAGAR_START';
export const FORNECEDORAPAGAR_SUCCESS = 'FORNECEDORAPAGAR_SUCCESS';
export const FORNECEDORAPAGAR_ERROR = 'FORNECEDORAPAGAR_ERROR';

export const FORNECEDORAPAGARTOTAIS = 'FORNECEDORAPAGARTOTAIS';
export const FORNECEDORAPAGARTOTAIS_START = 'FORNECEDORAPAGARTOTAIS_START';
export const FORNECEDORAPAGARTOTAIS_SUCCESS = 'FORNECEDORAPAGARTOTAIS_SUCCESS';
export const FORNECEDORAPAGARTOTAIS_ERROR = 'FORNECEDORAPAGARTOTAIS_ERROR';
